<template>
  <div>
    <v-row>
      <v-col cols="12" v-if="$vuetify.breakpoint.mdAndUp">
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" class="rounded-lg mt-5 primary--text">
              <v-row class="px-2">
                <v-col cols class="text-start ps-6">
                  {{ $t("user.registration.name") }}
                </v-col>

                <v-col cols class="text-start">
                  {{ $t("user.registration.organization") }}
                </v-col>

                <v-col cols class="text-start">
                  {{ $t("user.email") }}
                </v-col>

                <v-col cols class="text-start">
                  <span class="text-ellipse-1">
                    {{ $t("user.civilIdOrPassport") }}
                  </span>
                </v-col>

                <v-col cols="3" class="text-start">
                  {{ $t("user.employees.assignedRoles") }}
                </v-col>

                <v-col cols="auto">
                  <v-switch
                    flat
                    dense
                    hide-details
                    inset
                    color="success"
                    disabled
                    class="ma-0"
                    style="visibility: hidden; width: 46px"
                  >
                  </v-switch>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-row v-if="loading">
          <v-col cols="12">
            <v-progress-circular indeterminate color="primary">
            </v-progress-circular>
          </v-col>
        </v-row>
        
        <v-row v-else-if="datas.length" :key="reRender">
          <v-col cols="12" v-for="(data, index) in datas" :key="index">
            <employee-card
              :employeeData="data"
              :organizationsArr="organizations"
              :subRolesArr="subRoles"
              @editEmployee="editEmployee"
              @deleteEmployee="deleteUser"
              @updateErr="onError('update')"
            />
          </v-col>
        </v-row>

        <v-row
          v-else
          class="textLight--text font-weight-medium"
          align="center"
        >
          <v-col cols="12">
            {{ $t("noItems") }}
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <create-or-edit-employee
      v-if="employeeModal"
      :isCreate="isCreate"
      :employeeData="editData"
      :subRolesArr="subRoles"
      @close="closeModel"
      @afterCreate="afterCreate"
    />
  </div>
</template>

<script>
import EmployeeCard from "./EmployeeCard.vue";
import CreateOrEditEmployee from "./CreateOrEditEmployee.vue";

import { deleteEmployee } from "../methods/deleteEmployee";

export default {
  components: {
    EmployeeCard,
    CreateOrEditEmployee,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
    organizations: {
      type: Array,
      default: () => [],
    },
    subRoles: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      reRender: 0,
      employeeModal: false,
      editData: {},
      isCreate: false,
    };
  },

  methods: {
    deleteUser(id) {
      const msg =
        this.$i18n.locale === "ar"
          ? "سيتم حذف هذا الموظف بشكل دائم. هل أنت متأكد من الاستمرار؟"
          : "This employee will be deleted permanently. Are you sure to continue?";

      this.$dialog
        .confirm(msg)
        .then(() => {
          deleteEmployee(id).then(res => {
            if (res.data) this.$emit("reRender");
            if (res.error) {
              this.onError("delete");
            }
          });
        })
        .catch(_ => {});
    },
    onError(type) {
      let msg = null;
      if (type === "delete") {
        msg = this.$t("deleteFailed");
      }
      if (type === "update") {
        msg = this.$t("updateFailed");
      }
      this.$emit("responseErr", msg);
    },
    createEmployee() {
      this.editData = {};
      this.isCreate = true;
      this.employeeModal = true;
    },
    editEmployee(val) {
      if (val) {
        this.editData = val;
        this.isCreate = false;
        this.employeeModal = true;
      }
    },
    afterCreate() {
      this.$emit("reRender");
    },
    closeModel() {
      this.employeeModal = false;
    },
  },
};
</script>
